import {FilterFieldsOptions} from '@ui/ui.module';

import {FieldsOptions} from '@sim/form';

import {Attachment, AttachmentMeta} from './cards/attachament';


export enum EBaseType {
  'primary',
  'secondary'
}

export interface Base {
  readonly id?: string;
  codiceUnico: string;
  titolo: string;
  altezza: number;
  larghezza: number;
  profondita: number;
  dimensioniVarie: string[];
  peso: number;
  materiale: string[];
  note: string;
  tag: string[];
  allegati: Attachment[];
  tipo?: EBaseType;
}

// tslint:disable-next-line:no-empty-interface
export interface BaseFilter {
  codiceUnico: string;
  titolo: string;
  note: string;
  tag: string;
}

export const BaseMeta: FieldsOptions<any> = {
  allegati: {type: 'array', controls: AttachmentMeta, value: []},
  altezza: {},
  codiceUnico: {},
  dimensioniVarie: {type: 'array', value: []},
  id: {},
  larghezza: {},
  materiale: {type: 'array', value: []},
  note: {},
  peso: {},
  profondita: {},
  tag: {type: 'array', value: []},
  titolo: {},
};


export const BaseFilterMeta: FilterFieldsOptions<BaseFilter> = {
  codiceUnico: {operator: 'contains'},
  note: {operator: 'contains'},
  tag: {operator: 'contains'},
  titolo: {operator: 'contains'},
};
